/* globals Ya.share2 */

class YaShare2 {
	static select = $context => $context.select('.ya-share2');

	constructor($ya_share) {
		this.$ya_share = $ya_share;

		this.init();
	}

	init() {
		const self = this;
		if (self.$ya_share.hasClass('ya-share2_inited') || window.Ya === undefined || (window.Ya !== undefined && window.Ya.share2 === undefined)) {
			return;
		}
		window.Ya.share2(self.$ya_share.get(0));
	}

}

export default () => Component(YaShare2.select, $ya_share => new YaShare2($ya_share));
